export default function ({store}) {
  const linkList = [
    { href: 'https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css', type: 'text/css', rel: 'stylesheet' },
  ];

  function insertLink (linkContext) {
    const link = document.createElement('link');
    link.href = linkContext.href;
    if (linkContext.type) {
      link.type = linkContext.type;
    }
    if (linkContext.rel) {
      link.rel = linkContext.rel;
    }
    document.head.appendChild(link);
  }

  setTimeout(() => {
    linkList.forEach(item => {
      insertLink(item);
    });
  }, store.getters.getAnalyticsMarketingLoadTimeout);
}
